import * as React from 'react';
import { ChangePlanModalContextDetails } from './ChangePlanTypes';

export const ChangePlanModalContext = React.createContext<ChangePlanModalContextDetails>(
  null as any,
);

export const ChangePlanModalContextProvider: React.FC<ChangePlanModalContextDetails> = ({
  children,
  ...props
}) => {
  return (
    <ChangePlanModalContext.Provider value={props}>
      {children}
    </ChangePlanModalContext.Provider>
  );
};
